module.exports = __webpack_public_path__ + "nc_static/media/settings.7e28c499.svg";